import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { totalUser } from "../../services/dashboardService"
import React, { useEffect, useState } from 'react';
export default function StatsBar() {
    const [chartData, setChartData] = useState([{ name: '총 사용자' }]);
    const [keys, setKeys] = useState([]);
    const [total, setTotal] = useState();

    useEffect(() => {
        const token = localStorage.getItem("token");

        const fetchData = async () => {
            try {
                const response = await totalUser(token);
                console.log("state", response);
                if (response.success) {

                    const dynamicData = { name: '총 사용자' };
                    const keyList = [];

                    response.user_count.forEach(item => {
                        dynamicData[item.name] = item.count;
                        keyList.push(item.name);
                    });

                    setTotal(response.user_total_count ?? 0)
                    setChartData([dynamicData]);
                    setKeys(keyList);
                }
            } catch (error) {
                console.error('데이터 가져오기 실패:', error);
            }
        };

        fetchData();
    }, []);

    const colorMap = {
        고위험군: "#f87171",
        중위험군: "#facc15",
        저위험군: "#60a5fa",
        정상군: "#34d399"
    };

    const defaultColors = [
        "#f87171", "#facc15", "#60a5fa", "#34d399"
    ];

    return (
        <div className="stats_bar dashboard_box">
            <h4>총 사용자</h4>

            <div className="stats_txt01">
                <ul>
                    {keys.map((key, index) => (
                        <li key={key} className={`t0${index + 1}`}>{key}</li>
                    ))}
                </ul>
            </div>

            <div className="chart_box">
                <ResponsiveContainer width="100%" height={60}>
                    <BarChart
                        data={chartData}
                        layout="vertical"
                        stackOffset="expand"
                        barSize={49}
                        barCategoryGap={0}
                    >
                        <XAxis type="number" hide />
                        <YAxis type="category" dataKey="name" hide />
                        <Tooltip formatter={(value) => {
                            if (total > 0) {
                                return `${((value / total) * 100).toFixed(1)}%`;
                            }
                            return '0%';
                        }} />
                        {keys.map((key, index) => (
                            <Bar
                                key={key}
                                dataKey={key}
                                stackId="a"
                                fill={colorMap[key] || defaultColors[index % defaultColors.length]}
                            />
                        ))}
                    </BarChart>
                </ResponsiveContainer>
            </div>

            <div className="stats_txt02">
                <ul>
                    {keys.map(key => (
                        <li key={key}>
                            <span>{key} :</span> {chartData[0][key] ?? 0}명
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}